module.exports = __webpack_public_path__ + "static/media/arrowBm@4x.ad4323a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrowBm@4x.png
// module id = 233
// module chunks = 0 1